/** Insert blank line before ATX headings when model omits it (e.g. "...projects## Team"). */
export function normalizeMarkdownHeadings(content: string): string {
	let inCodeBlock = false;

	return content
		.split('\n')
		.map(line => {
			const trimmedStart = line.trimStart();
			if (trimmedStart.startsWith('```')) {
				inCodeBlock = !inCodeBlock;
				return line;
			}
			if (inCodeBlock) {
				return line;
			}
			// GFM table rows can contain "#" in cell text — do not rewrite those lines.
			if (line.includes('|')) {
				return line;
			}
			// Only fix level-2+ headings (## …) to avoid splitting prose like "C# language".
			return line.replace(/([^\n#])(#{2,6}\s)/g, '$1\n\n$2');
		})
		.join('\n');
}
